import { useEffect, useState } from 'react';
import Select from 'react-select';
import { BaseSelector } from '../../../domain/shared';
import { EmployeesRepository } from '../../../infrastructure/repositories/employees/employeeRepository';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined | number[];
    name: string;
}

export default function EmployeeSelector({ onChange, value, name }: Props) {
    const [cities, setCities] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        EmployeesRepository.GetEmployeesListSelector().then((res) => {
            setIsLoading(false);
            setCities(
                res.map((c) => ({
                    label: `${c.firstName} ${c.middleName} ${c.lastName} ${c.surname} - ${c.position}`,
                    value: c.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Responsables
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={cities}
                onChange={(c) => {
                    onChange(name, c?.value);
                }}
                value={
                    cities.find((c) => c.value === value) ?? {
                        label: 'Seleccione',
                        value: 0,
                    }
                }
            />
        </div>
    );
}
